import { UserRole } from '@bco/types';
import {
  authApi,
  BascSelect,
  clientsApi,
  useAuthStore,
  type ClientListItem,
} from '@bco/ui';
import { useCallback, useEffect, useState } from 'react';

interface ClientSelectorProps {
  currentClientName: string;
}

export function ClientSelector({ currentClientName }: ClientSelectorProps) {
  const { user, setUser } = useAuthStore();
  const [clients, setClients] = useState<ClientListItem[]>([]);
  const [switching, setSwitching] = useState(false);

  useEffect(() => {
    if (user?.role !== UserRole.PlatformAdmin) {
      return;
    }

    clientsApi
      .list()
      .then(setClients)
      .catch(() => {});
  }, [user?.role]);

  const handleSwitch = useCallback(
    async (value: string | null) => {
      if (!value || value === currentClientName || switching) {
        return;
      }

      setSwitching(true);
      try {
        const response = await authApi.switchClient(value);
        setUser(response.user);
        window.location.href = `/${value}/dashboard`;
      } finally {
        setSwitching(false);
      }
    },
    [currentClientName, switching, setUser]
  );

  if (user?.role !== UserRole.PlatformAdmin || clients.length < 2) {
    return null;
  }

  return (
    <BascSelect
      size="xs"
      data={clients.map((c) => ({ value: c.clientId, label: c.displayName }))}
      value={currentClientName}
      onChange={handleSwitch}
      disabled={switching}
      styles={{ input: { minWidth: 160 } }}
      allowDeselect={false}
    />
  );
}
